// Marquee-Hit-Test: liefert alle Objekte deren Bounding-Box das Rechteck schneidet.
// Wiederverwendet `objectBounds` aus object-bounds.ts (Slice 1-erweitert mit block/region).

import type { CanvasObject } from "@ms-whiteboard/shared";
import { objectBounds } from "./object-bounds.js";

export interface MarqueeRect {
  /** Worldspace-Koordinaten. */
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

/** Berechnet aus zwei Punkten (Start, aktuell) ein normalisiertes Rechteck. */
export function normalizeRect(
  start: { x: number; y: number },
  end: { x: number; y: number },
): MarqueeRect {
  const x = Math.min(start.x, end.x);
  const y = Math.min(start.y, end.y);
  const width = Math.abs(end.x - start.x);
  const height = Math.abs(end.y - start.y);
  return { x, y, width, height };
}

/** Pruft ob ein Objekt mit dem Marquee-Rechteck Schnittflaeche hat (>0). */
export function rectIntersectsObject(rect: MarqueeRect, obj: CanvasObject): boolean {
  const b = objectBounds(obj);
  const ox = obj.x;
  const oy = obj.y;
  const ow = b.w;
  const oh = b.h;
  // AABB-Intersection: keine Ueberlappung wenn ein Rechteck links/rechts/oben/unten ist.
  if (rect.x + rect.width < ox) return false;
  if (ox + ow < rect.x) return false;
  if (rect.y + rect.height < oy) return false;
  if (oy + oh < rect.y) return false;
  return true;
}

export function pickObjectsInRect(rect: MarqueeRect, objects: Iterable<CanvasObject>): string[] {
  const result: string[] = [];
  for (const obj of objects) {
    if (rectIntersectsObject(rect, obj)) result.push(obj.id);
  }
  return result;
}
